import { type ReactNode } from 'react';

import { Grid } from '@mui/material';
import { type PaginationState, type Updater } from '@tanstack/react-table';

import ColumnsButton from 'components/buttons/ColumnsButton';
import { useStyles as usePlayerStyles } from 'components/tables/players/styles';

import EnhancedPagination from './EnhancedPagination';
import { type TPaginationClasses } from './utils';

interface EnhancedActionsProps {
  additionalButtons: ReactNode;
  columnsToggle: boolean;
  manualPagination: boolean;
  numOfSelectedRows: number;
  pageIndex: number;
  paginationClassNames: Partial<Record<TPaginationClasses, string>>;
  paginationOptions: (
    | number
    | {
        label: string;
        value: number;
      }
  )[];
  paginationState: PaginationState;
  rowsCount: number;
  selectedActions: ReactNode;
  onGetPageCount: () => number;
  onGetRowCount: () => number;
  onHandleShowColumnsMenu: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, page: number) => void;
  onPaginationSizeChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onSetPageIndex: (updater: Updater<number>) => void;
  onSetPageSize: (updater: Updater<number>) => void;
}

const EnhancedActions = ({
  additionalButtons,
  columnsToggle,
  manualPagination,
  numOfSelectedRows,
  pageIndex,
  paginationClassNames,
  paginationOptions,
  paginationState,
  rowsCount,
  selectedActions,
  onGetPageCount,
  onGetRowCount,
  onHandleShowColumnsMenu,
  onPageChange,
  onPaginationSizeChange,
  onSetPageIndex,
  onSetPageSize,
}: EnhancedActionsProps) => {
  const { classes: playerClasses } = usePlayerStyles();

  return (
    <Grid container className={playerClasses.showing} direction="row" justifyContent="space-between">
      <Grid item>
        {rowsCount > 0 &&
          ((pageIndex !== undefined && numOfSelectedRows === 0) || (pageIndex !== undefined && !selectedActions) ? (
            <EnhancedPagination
              classNames={paginationClassNames}
              manualPagination={manualPagination}
              paginationOptions={paginationOptions}
              paginationState={paginationState}
              onGetPageCount={onGetPageCount}
              onGetRowCount={onGetRowCount}
              onPageChange={onPageChange}
              onPaginationSizeChange={onPaginationSizeChange}
              onSetPageIndex={onSetPageIndex}
              onSetPageSize={onSetPageSize}
            />
          ) : (
            selectedActions
          ))}
      </Grid>
      <Grid item>
        <Grid container direction="row" rowSpacing={1} spacing={2}>
          <Grid item>{additionalButtons}</Grid>
          {columnsToggle && !!rowsCount && (
            <Grid item>
              <ColumnsButton onClick={onHandleShowColumnsMenu} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EnhancedActions;
